export default "__VITE_ASSET__58b19e29__"